import { useSidebar } from "@/lib/context/sidebar-context";

export function SidebarLayout({ children }: { children: React.ReactNode }) {
  const { isOpen, width } = useSidebar();

  // Calculate the left margin: vertical tab bar + sidebar width when open
  // When closed: 44px, When open: 48px + sidebar width
  const tabBarWidth = isOpen ? 48 : 44;
  const marginLeft = isOpen ? width + tabBarWidth : tabBarWidth;

  return (
    <div
      className="transition-all duration-300 ease-in-out"
      style={{ marginLeft: `${marginLeft}px` }}
    >
      {children}
    </div>
  );
}
